import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

// Estado inicial solo para inventoryReport y filtros principales
function initSession () {
  const session = {
    inventoryReport: {
      tableData: [],
      totalInventoryReport: 0
    },
    queryInventoryReport: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersInventoryReport: [],
    // combos principales
    optionsFilterServiceInventoryReport: [],
    optionsFilterSellerCompanyInventoryReport: [],
    optionsFilterBuyerCompanyInventoryReport: [],
    optionsFilterPointOfStoreInventoryReport: [],
    optionsFilterDocumentNumberInventoryReport: [],
    optionsFilterQuantityIncomingDateInventoryReport: [],
    optionsFilterArticleCodeInventoryReport: []
  }
  return session
}

function initLocal () {
  const local = {
    isShowServiceInventoryReport: true,
    isShowSellerCompanyInventoryReport: true,
    isShowBuyerCompanyInventoryReport: true,
    isShowPointOfStoreInventoryReport: true,
    isShowDocumentNumberInventoryReport: true,
    isShowDocumentDateInventoryReport: true,
    isShowQuantityIncomingDateInventoryReport: true,
    isShowArticleCodeInventoryReport: true,
    isShowQuantityTargetInventoryReport: true,
    isShowQuantityIncomingInventoryReport: true,
    isShowQuantityStockInventoryReport: true,
    isShowCreationDateTimeInventoryReport: true
  }
  return local
}

function setByUserLocalInventoryReport () {
  if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))?.inventoryReport) {
    const local = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).inventoryReport
    return local
  } else {
    return initLocal()
  }
}

// state
const state = {
  userConfigLocalStorage: '',
  local: initLocal(),
  session: initSession()
}

// getters
const getters = {
  inventoryReport: state => state.session.inventoryReport,
  queryInventoryReport: state => state.session.queryInventoryReport,
  listSelectedFiltersInventoryReport: state => state.session.listSelectedFiltersInventoryReport,
  // combos
  optionsFilterServiceInventoryReport: state => state.session.optionsFilterServiceInventoryReport,
  optionsFilterSellerCompanyInventoryReport: state => state.session.optionsFilterSellerCompanyInventoryReport,
  optionsFilterBuyerCompanyInventoryReport: state => state.session.optionsFilterBuyerCompanyInventoryReport,
  optionsFilterPointOfStoreInventoryReport: state => state.session.optionsFilterPointOfStoreInventoryReport,
  optionsFilterDocumentNumberInventoryReport: state => state.session.optionsFilterDocumentNumberInventoryReport,
  optionsFilterQuantityIncomingDateInventoryReport: state => state.session.optionsFilterQuantityIncomingDateInventoryReport,
  optionsFilterArticleCodeInventoryReport: state => state.session.optionsFilterArticleCodeInventoryReport,
  // columnas tabla
  isShowServiceInventoryReport: state => state.local.isShowServiceInventoryReport,
  isShowSellerCompanyInventoryReport: state => state.local.isShowSellerCompanyInventoryReport,
  isShowBuyerCompanyInventoryReport: state => state.local.isShowBuyerCompanyInventoryReport,
  isShowPointOfStoreInventoryReport: state => state.local.isShowPointOfStoreInventoryReport,
  isShowDocumentNumberInventoryReport: state => state.local.isShowDocumentNumberInventoryReport,
  isShowDocumentDateInventoryReport: state => state.local.isShowDocumentDateInventoryReport,
  isShowQuantityIncomingInventoryReport: state => state.local.isShowQuantityIncomingInventoryReport,
  isShowArticleCodeInventoryReport: state => state.local.isShowArticleCodeInventoryReport,
  isShowQuantityTargetInventoryReport: state => state.local.isShowQuantityTargetInventoryReport,
  isShowQuantityIncomingDateInventoryReport: state => state.local.isShowQuantityIncomingDateInventoryReport,
  isShowQuantityStockInventoryReport: state => state.local.isShowQuantityStockInventoryReport,
  isShowCreationDateTimeInventoryReport: state => state.local.isShowCreationDateTimeInventoryReport
}

// actions
const actions = {
  setUserNameInventoryReport ({ state }) {
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalInventoryReport()
    }
  },

async getInventoryReports ({ commit }, data) {
    try {
      // Solo enviar los parámetros activos del filtro
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/inventoryreport',
        params: {
          ...data.query
        },
        headers: { 'Accept-Language': data.activeLang },
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      commit('INVENTORYREPORT_STATE', {
        tableData: response.data.content,
        totalInventoryReport: response.data.totalElements
      })
      return response.data
    } catch (error) {
      // Organización de errores por servicio
      if (error?.response?.status === 404) {
        // Si la respuesta es vacía pero sin error, limpiar la tabla sin mostrar mensajes de error
        commit('INVENTORYREPORT_STATE', {
          tableData: [],
          totalInventoryReport: 0
        })
        return { content: [], totalElements: 0 }
      }
      throw error.response
    }
  },

  // Servicio para descargar inventory report en formato CSV
  async downloadInventoryReportCsv ({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/inventoryreport/csv',
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'inventoryreport.csv'
      const fileGroup = /([^;]+;_+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup?.[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      throw error.response
    }
  },

  // Servicio para descargar inventory report en formato original (ej: XML, PDF, etc)
  async downloadInventoryReportOriginal({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      // Envío correcto de inventoryReportsId: solo el ID clicado si existe
      if (params.inventoryReportsId && Array.isArray(params.inventoryReportsId)) {
        params.inventoryReportsId = [params.inventoryReportsId[0]]
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/inventoryreport/original',
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'inventoryreport-original.zip'
      const fileGroup = /([^;]+;_+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup?.[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      throw error.response
    }
  },

  // Servicio para descargar metadata del inventory report
  async downloadInventoryReportMetadata({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      // Envío correcto de inventoryReportsId: solo el ID clicado si existe
      if (params.inventoryReportsId && Array.isArray(params.inventoryReportsId)) {
        params.inventoryReportsId = [params.inventoryReportsId[0]]
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/inventoryreport/metadata',
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'inventoryreport-metadata.zip'
      const fileGroup = /([^;]+;_+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup?.[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      throw error.response
    }
  },


  // Métodos para limpiar y actualizar filtros activos
  async listSelectedFiltersInventoryReportState({ commit }, payload) {
    commit('LIST_SELECTED_FILTERS_INVENTORYREPORT_STATE', payload)
  },
  async queryInventoryReportState({ commit }, payload) {
    commit('QUERY_INVENTORYREPORT_STATE', payload)
  },
  async inventoryReportState({ commit }, payload) {
    commit('INVENTORYREPORT_STATE', payload)
  },

  // Métodos para columnas visibles
  isShowServiceInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_INVENTORYREPORT', payload)
  },
  isShowSellerCompanyInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_COMPANY_INVENTORYREPORT', payload)
  },
  isShowBuyerCompanyInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_COMPANY_INVENTORYREPORT', payload)
  },
  isShowPointOfStoreInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_POINT_OF_STORE_INVENTORYREPORT', payload)
  },
  isShowDocumentNumberInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_DOCUMENT_NUMBER_INVENTORYREPORT', payload)
  },
  isShowDocumentDateInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_DOCUMENT_DATE_INVENTORYREPORT', payload)
  },
  isShowQuantityIncomingDateInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_QUANTITY_INCOMING_DATE_INVENTORYREPORT', payload)
  },
  isShowArticleCodeInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_ARTICLE_CODE_INVENTORYREPORT', payload)
  },
  isShowQuantityTargetInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_QUANTITY_TARGET_INVENTORYREPORT', payload)
  },
  isShowQuantityIncomingInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_QUANTITY_INCOMING_INVENTORYREPORT', payload)
  },
  isShowQuantityStockInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_QUANTITY_STOCK_INVENTORYREPORT', payload)
  },
  isShowCreationDateTimeInventoryReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_CREATION_DATE_TIME_INVENTORYREPORT', payload)
  }
}

// mutations
const mutations = {
  resetSessionInventoryReport (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  'INVENTORYREPORT_STATE' (state, payload) {
    state.session.inventoryReport = payload
  },
  'QUERY_INVENTORYREPORT_STATE' (state, payload) {
    state.session.queryInventoryReport = payload
  },
  'LIST_SELECTED_FILTERS_INVENTORYREPORT_STATE' (state, payload) {
    state.session.listSelectedFiltersInventoryReport = payload
  },
  // combos
  'OPTIONS_FILTER_SERVICE_INVENTORYREPORT' (state, payload) {
    state.session.optionsFilterServiceInventoryReport = payload
  },
  'OPTIONS_FILTER_SELLER_COMPANY_INVENTORYREPORT' (state, payload) {
    state.session.optionsFilterSellerCompanyInventoryReport = payload
  },
  'OPTIONS_FILTER_BUYER_COMPANY_INVENTORYREPORT' (state, payload) {
    state.session.optionsFilterBuyerCompanyInventoryReport = payload
  },
  'OPTIONS_FILTER_POINT_OF_STORE_INVENTORYREPORT' (state, payload) {
    state.session.optionsFilterPointOfStoreInventoryReport = payload
  },
  'OPTIONS_FILTER_DOCUMENT_NUMBER_INVENTORYREPORT' (state, payload) {
    state.session.optionsFilterDocumentNumberInventoryReport = payload
  },
  'OPTIONS_FILTER_QUANTITY_INCOMING_DATE_INVENTORYREPORT' (state, payload) {
    state.session.optionsFilterQuantityIncomingDateInventoryReport = payload
  },
  'OPTIONS_FILTER_ARTICLE_CODE_INVENTORYREPORT' (state, payload) {
    state.session.optionsFilterArticleCodeInventoryReport = payload
  },
  // columnas tabla
  'IS_SHOW_SERVICE_INVENTORYREPORT' (state, payload) {
    state.local.isShowServiceInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowServiceInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_COMPANY_INVENTORYREPORT' (state, payload) {
    state.local.isShowSellerCompanyInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowSellerCompanyInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_BUYER_COMPANY_INVENTORYREPORT' (state, payload) {
    state.local.isShowBuyerCompanyInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowBuyerCompanyInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_POINT_OF_STORE_INVENTORYREPORT' (state, payload) {
    state.local.isShowPointOfStoreInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowPointOfStoreInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DOCUMENT_NUMBER_INVENTORYREPORT' (state, payload) {
    state.local.isShowDocumentNumberInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowDocumentNumberInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DOCUMENT_DATE_INVENTORYREPORT' (state, payload) {
    state.local.isShowDocumentDateInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowDocumentDateInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_QUANTITY_INCOMING_DATE_INVENTORYREPORT' (state, payload) {
    state.local.isShowQuantityIncomingDateInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowQuantityIncomingDateInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ARTICLE_CODE_INVENTORYREPORT' (state, payload) {
    state.local.isShowArticleCodeInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowArticleCodeInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_QUANTITY_TARGET_INVENTORYREPORT' (state, payload) {
    state.local.isShowQuantityTargetInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowQuantityTargetInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_QUANTITY_INCOMING_INVENTORYREPORT' (state, payload) {
    state.local.isShowQuantityIncomingInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowQuantityIncomingInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_QUANTITY_STOCK_INVENTORYREPORT' (state, payload) {
    state.local.isShowQuantityStockInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowQuantityStockInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CREATION_DATE_TIME_INVENTORYREPORT' (state, payload) {
    state.local.isShowCreationDateTimeInventoryReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.inventoryReport) storeuser.inventoryReport = {}
    storeuser.inventoryReport.isShowCreationDateTimeInventoryReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
